import { render, staticRenderFns } from "./ysApply.vue?vue&type=template&id=9c649186&scoped=true&"
import script from "./ysApply.vue?vue&type=script&lang=js&"
export * from "./ysApply.vue?vue&type=script&lang=js&"
import style0 from "./ysApply.vue?vue&type=style&index=0&id=9c649186&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c649186",
  null
  
)

export default component.exports